import { StaticPageContent } from '../StaticPageContent/StaticPageContent';
import { StaticPageHeader } from '../StaticPageHeader/StaticPageHeader';
import { StaticPageNavigation } from '../StaticPageNavigation/StaticPageNavigation';
import { StaticPageSection } from '../StaticPageSection/StaticPageSection';
import { StaticPageSections } from '../StaticPageSections/StaticPageSections';
import type { StaticLookupRegistry, StaticPageJSONData } from '../types';

type StaticPageProps = {
  data: StaticPageJSONData;
  lookupData?: StaticLookupRegistry;
};

/**
 * A complete JSON-driven static page.
 *
 * Composes {@link StaticPageHeader}, a {@link StaticPageNavigation} contents
 * index and one {@link StaticPageSection} per section, so a route only imports
 * its `data.json` and renders this component. Render inside the app's static
 * layout.
 *
 * @param data - Page title, optional last updated line, navigation copy and sections from `data.json`
 * @param lookupData - Route-owned datasets referenced by lookup blocks
 */
function StaticPage({ data, lookupData }: StaticPageProps) {
  const { title, lastUpdated, navigation, sections } = data;

  return (
    <>
      <StaticPageHeader title={title} lastUpdated={lastUpdated} />
      <StaticPageContent>
        <StaticPageNavigation title={navigation.title} intro={navigation.intro} sections={sections} />
        <StaticPageSections>
          {sections.map(section => (
            <StaticPageSection key={section.title} section={section} backToTopLabel={navigation.backToTop} lookupData={lookupData} />
          ))}
        </StaticPageSections>
      </StaticPageContent>
    </>
  );
}

export { StaticPage, type StaticPageProps };
